import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { Form, Checkbox, notification } from 'antd';
import axios from 'axios';
import _ from 'lodash';

import { guestUserLogin } from '../../appRedux/actions/Auth';
import { LOCAL_STORAGE_VAR } from '../../constants/Common';
import { GUEST_LOGIN_USER } from '../../constants/apiConstant';
import UtilService from '../../services/util';
import IntlMessages from '../../util/IntlMessages';
import LangDropdown from '../Header/LangDropdown';
import BackButton from '../common/BackButton';
import OpenNotification from '../common/CommonButton/OpenNotification';
import InputBlock from '../common/InputBlock';
import Loader from '../common/Loader';
import SocialIcon from '../common/SocialIcon';

const isChanged = {};

class GuestLoginFrom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guestFields: {
        firstName: '',
        lastName: '',
        companyName: '',
        mobile: '',
        email: '',
        updateRequired: false,
      },
      checked: false,
      errors: {},
    };
    this.handleGuestLogin = this.handleGuestLogin.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleGuestLogin = (e) => {
    const self = this;
    e.preventDefault();
    const reqObj = _.clone(this.state.guestFields);
    if (this.state.checked) {
      if (this.handleValidation()) {
        const objData = {
          ...GUEST_LOGIN_USER,
          request: {
            ...reqObj,
            masters: [
              'COLOR',
              'CLARITY',
              'SHAPE',
              'CUT',
              'FLUORESCENCE',
              'SHADE',
              'LAB',
              'POLISH',
              'SYMMETRY',
              'LOCATION',
              'BLACK_INCLUSION',
              'WHITE_INCLUSION',
              'OPEN_TABLE',
              'MILKEY',
              'WHITE_INCLUSION_CROWN',
              'OPEN_CROWN',
              'EYECLEAN',
              'OPEN_PAVILION',
              'ORIGIN',
              'BLACK_INCLUSION_CROWN',
              'H_AND_A',
              'WHITE_INCLUSION_TABLE',
              'FANCY_COLOR',
              'INTENSITY',
              'OVERTONE',
              'KEY_TO_SYMBOLS',
              'GIRDLE',
              'CULET',
              'GIRDLE_COND',
              'CULET_COND',
              'COMPANY_SIZE',
              'MIX_TINT',
              'NATURAL',
              'OPEN_INCLUSION',
            ],
          },
        };
        UtilService.callApi(objData, async (err, data) => {
          if (err) {
            return OpenNotification({
              type: 'error',
              title: err.data.message || err.data.data.message || 'Failed to Login.',
            });
          }
          if (data && data.code === 'OK') {
            self.getRedirection(data);
          }
        });
      }
    } else {
      OpenNotification({
        type: 'error',
        title: 'You must be agree to terms and condition to create an account',
      });
    }
  };

  getRedirection = (data) => {
    const user = data.data.user;
    // if (
    //   data.data.userPermissions &&
    //   (!data.data.userPermissions.data || !data.data.userPermissions.data.length)
    // ) {
    //   return OpenNotification({
    //     type: "error",
    //     title: "Failed to Login.",
    //   });
    // }
    const stepDisplay = {
      dashboard: !user.isIntoHide,
      diamondSearch: !user.isIntoHide,
      searchResult: !user.isIntoHide,
      diamondDetails: !user.isIntoHide,
    };

    const masters = data.data.masters;
    const columns = data.data.columns;
    const userPermissions = data.data.userPermissions;
    const keywords = data.data.keywords;
    const token = data.data.token.jwt;

    // localStorage.setItem(`${LOCAL_STORAGE_VAR}-token`, JSON.stringify(token));
    // localStorage.setItem(`${LOCAL_STORAGE_VAR}-user`, JSON.stringify(user));

    UtilService.setLocalStorageItem(token, `${LOCAL_STORAGE_VAR}-token`);
    UtilService.setLocalStorageItem(user, `${LOCAL_STORAGE_VAR}-user`);

    localStorage.setItem(`${LOCAL_STORAGE_VAR}-master`, JSON.stringify(masters));
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-column`, JSON.stringify(columns));
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-keywords`, JSON.stringify(keywords));
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-tooltip-steps`, JSON.stringify(stepDisplay));

    localStorage.setItem(`${LOCAL_STORAGE_VAR}-isTrusted`, data.data.isTrusted);
    const setPermit = {};
    userPermissions.data.map((x) => {
      if (x.module === 'order' && user.Setting) {
        x.permissions.insert = user.Setting.Is_PlaceOrder ? user.Setting.Is_PlaceOrder : false;
      }

      if (x.module === 'pricing' && user.Setting && user.Setting.Is_NoPrice !== true) {
        x.permissions.view = user.Setting.Is_NoPrice !== true ? true : false;
        x.permissions.all = user.Setting.Is_NoPrice !== true ? true : false;
      }

      setPermit[x.module] = x.permissions;
    });

    if (setPermit && !setPermit.pricing) {
      if (user.Setting && user.Setting.Is_NoPrice !== true) {
        setPermit.pricing = {};
        setPermit.pricing.view = user.Setting.Is_NoPrice !== true ? true : false;
        setPermit.pricing.all = user.Setting.Is_NoPrice !== true ? true : false;
      }
    }

    // localStorage.setItem(
    //   `${LOCAL_STORAGE_VAR}-userPermissions`,
    //   JSON.stringify(setPermit)
    // );
    UtilService.setLocalStorageItem(setPermit, `${LOCAL_STORAGE_VAR}-userPermissions`);

    axios.defaults.headers.common['access-token'] = 'JWT ' + token;
    this.props.history.push('/dashboard');
  };

  handleValidation = () => {
    const formData = this.state.guestFields;
    const errors = this.state.errors;
    let formIsValid = true;
    const blankField = [];
    const invalidFields = [];
    if (!formData['firstName'] || _.isEmpty(formData['firstName'])) {
      blankField.push('First Name');
      errors['firstName'] = true;
      formIsValid = false;
    }
    if (formData['firstName']) {
      if (!formData['firstName'].match(/^[a-zA-Z ]+$/)) {
        invalidFields.push('firstName');
        formIsValid = false;
        errors['firstName'] = true; //"Please enter valid First Name.";
      } else {
        errors['firstName'] = undefined;
      }
    }
    if (formData['lastName']) {
      if (!formData['lastName'].match(/^[a-zA-Z ]+$/)) {
        invalidFields.push('lastName');
        formIsValid = false;
        errors['lastName'] = true; //"Please enter valid First Name.";
      } else {
        errors['lastName'] = undefined;
      }
    }
    if (!formData['lastName'] || _.isEmpty(formData['lastName'])) {
      blankField.push('Last Name');
      errors['lastName'] = true;
      formIsValid = false;
    }
    if (!formData['email'] || _.isEmpty(formData['email'])) {
      blankField.push('Email');
      errors['email'] = true;
      formIsValid = false;
    }
    if (formData['email']) {
      const lastAtPos = formData['email'].lastIndexOf('@');
      const lastDotPos = formData['email'].lastIndexOf('.');

      if (formData['email'] && !formData['email'].match(/^[a-zA-Z0-9]+[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z.]{2,10}$/)) {
        formIsValid = false;
        invalidFields.push('email');
        errors['email'] = true; //"Please enter valid email address.";
      }
    }
    if (!formData['mobile'] || _.isEmpty(formData['mobile'])) {
      blankField.push('Mobile');
      errors['mobile'] = true;
      formIsValid = false;
    }

    if (formData['mobile']) {
      if (!formData['mobile'].match(/(^[0-9]*)$/)) {
        formIsValid = false;
        invalidFields.push('mobile');
        errors['mobile'] = true; //"Please enter valid email address.";
      } else {
        errors['mobile'] = undefined;
        // errors["mobile"] = undefined;
      }
    }
    // if (!formData["companyName"] || _.isEmpty(formData["companyName"])) {
    //   blankField.push("Company Name");
    //   errors["companyName"] = true;
    //   formIsValid = false;
    // }

    if (blankField.length > 0) {
      const arr = blankField;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }
      notification.error({
        message: 'Required Fields',
        placement: 'bottomLeft',
        description: outStr,
      });
    }
    if (invalidFields.length > 0) {
      const arr = invalidFields;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }
      notification.error({
        message: 'Invalid Fields',
        placement: 'bottomLeft',
        description: outStr,
      });
    }
    this.setState({ errors: errors });
    return formIsValid;
  };

  // handleOnChange = (key, value) => {
  //   let { guestFields } = this.state;
  //   guestFields[key] = value;
  //   this.setState(guestFields);
  // };

  handleOnChange(key, value) {
    const { guestFields } = this.state;
    if (key === 'mobile') {
      const re = /^[0-9\b]+$/;
      if (value === '' || re.test(value)) {
        if (guestFields[key].length === 0) {
          if (value === '0') {
            guestFields[key] = value.trim();
          } else {
            guestFields[key] = value.trim();
          }
        } else {
          guestFields[key] = value.trim();
        }
      }
    } else {
      guestFields[key] = value;
    }

    this.setState({ guestFields });
  }
  render() {
    const { guestFields, errors } = this.state;
    return (
      <div className="loginDetail">
        <div className="loginBox">
          <Loader loading={this.props.loading} />
          <Form autoComplete="off" className="signup-form" onSubmit={this.handleGuestLogin}>
            <div className="registerFiledBlock twoBlockItem">
              <InputBlock
                onChange={(e) => this.handleOnChange('firstName', e.target.value)}
                requireds
                value={guestFields.firstName}
                type="text"
                label="First Name"
                placeholder="First Name"
                hasError={errors['firstName'] ? true : false}
              />
              <InputBlock
                requireds
                onChange={(e) => this.handleOnChange('lastName', e.target.value)}
                value={guestFields.lastName}
                type="text"
                label="Last Name"
                placeholder="Last Name"
                hasError={errors['lastName'] ? true : false}
              />
              <InputBlock
                requireds
                onChange={(e) => this.handleOnChange('email', e.target.value)}
                value={guestFields.email}
                type="text"
                label="Email"
                placeholder="Email"
                hasError={errors['email'] ? true : false}
              />
              <InputBlock
                requireds
                onChange={(e) => this.handleOnChange('mobile', e.target.value)}
                value={guestFields.mobile}
                type="text"
                label="Mobile Number"
                placeholder="Mobile Number"
                hasError={errors['mobile'] ? true : false}
              />
              <InputBlock
                onChange={(e) => this.handleOnChange('companyName', e.target.value)}
                value={guestFields.companyName}
                type="text"
                label="Company Name"
                placeholder="Company Name"
                hasError={errors['companyName'] ? true : false}
              />
            </div>

            <div>
              <Checkbox
                checked={this.state.checked}
                onChange={() => {
                  this.setState({ checked: !this.state.checked });
                }}
              >
                I have read and accept <a className="linkTag">Terms and Conditions.</a>
              </Checkbox>
            </div>
            <div className="mt-10">
              <Checkbox
                checked={this.state.guestFields.updateRequired}
                onChange={() => {
                  const { guestFields } = this.state;
                  guestFields['updateRequired'] = !this.state.guestFields.updateRequired;
                  this.setState(guestFields);
                }}
              >
                Promotional offers, newsletters and stock updates
              </Checkbox>
            </div>
            <div className="mt-30 loginButton">
              <button type="submit" className="commonButton">
                Log In
              </button>
              <div className="registerLogLink">
                Don’t have registration in details?
                <Link to="/signup">
                  <IntlMessages id="app.signin.register" />
                </Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const WrappedLoginForm = Form.create()(GuestLoginFrom);

const mapStateToProps = ({ auth, commonData }) => {
  const { token } = auth;
  const { loading } = commonData;
  return { token, loading };
};

export default connect(mapStateToProps, { guestUserLogin })(withRouter(WrappedLoginForm));
